import { render, staticRenderFns } from "./CBlockListOneLarge.vue?vue&type=template&id=3886e928&"
import script from "./CBlockListOneLarge.vue?vue&type=script&lang=ts&"
export * from "./CBlockListOneLarge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports